var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"15px"}},[_c('router-view',{key:_vm.$route.path + _vm.$route.query + _vm.$route.params})],1)}
var staticRenderFns = []

export { render, staticRenderFns }